import FadeInModal from './FadeInModal';

export default FadeInModal;
